<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 施設情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>施設情報の説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/facility.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 追加ボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。<br>
          ※展示登録数には制限があります。制限数を変更したい場合は弊社担当へご連絡下さい。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した情報を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter・属性
        </div>
        <div class="manual-explain">
          施設一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: ID、名称、属性（プルダウンによるフィルタリング）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 施設一覧
        </div>
        <div class="manual-explain">
          登録済みの施設情報の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。<br>
          また、本番反映ボタンで<a [href]="reflectDataLink">本番反映ダイアログ</a>が開き、本番反映の予約設定等が行えます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Facility Information
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Facility Information</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_facility.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add Button
        </div>
        <div class="manual-explain">
          Clicking this button will display the add screen.<br>
          * There is a limit to the number of facility registrations. If you wish to change the limit, please contact our representative.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>
        <div class="manual-explain">
          Clicking this button will delete the selected information.<br>
          The button is enabled by checking the delete checkbox in the list.
        </div>
        
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter · Attributes
        </div>
        <div class="manual-explain">
          Filters the data displayed in the facility list.<br>
          * Filtering criteria: ID, name, and attributes (filtered via dropdown).
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Facility List
        </div>
        <div class="manual-explain">
          Displays a list of registered facility information.<br>
          Clicking the edit icon will open the edit screen.<br>
          Additionally, clicking the "Apply to Production" button will open the <a [href]="reflectDataLink">Apply to Production Dialog</a>, where you can configure production application settings.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>